/**
 * Created by intellicar-rinas on 4/10/17.
 */
import {
  schemaTypes,
  dateFormat,
  fuelTypeMap,
  simpleTimeFormat,
} from "../../../constants/constants";
import ReportAPIs from "../../../APIs/ReportAPIs";
import GeoCodeAPIs from "../../../APIs/GeoCodeAPIs";
import { JSONToCSVConvertor, stripLoc } from "../../../helpers/helperFunctions";
import momentTZ from "moment-timezone";
import {
  flipRange,
  canShowRangeSwitch,
  onFetchOdo,
  changeVehicle,
} from "./historyReport/historyReport";
import moment from "moment";
import _ from "lodash";
import { getFuelPrices } from "./tripReport";
import { duration as formatChange } from "../reports/railwaysReport/railwaysReport";
// import mixpanel from "mixpanel-browser";
import { isEvGroup } from "../reports/summaryReport";
import actions from "../../../store/actions";

export const changeToHours = (dur) => {
  if (!dur) return "--";
  // get hours & multiply fractional part by 60 to get minutes
  let hrs = dur / 60;
  let min = parseInt((hrs % 1) * 60, 10);
  hrs = parseInt(hrs, 10);
  let els = min + " min";
  if (hrs > 0) els = hrs + " hrs " + els;
  return els;
};
const isIdlingShowable = (item, props) => {
  let groups = props.groupTree.children.map((g) => g.name);
  let disable =
    ((window.userInfo || {}).SELF || {}).disableIdlingFromReports !== "DISABLE";
  if (groups.includes("KushalSSLLP")) return false;
  return disable;
};

const filterHeading = [
  {
    users: ["unilet.blr"],
    // blacklist: [],
    whitelist: [
      "vehicleno",
      "starttime",
      "endtime",
      "distance",
      "startloc",
      "endloc",
    ],
  },
];

const isRangeShow = (item) => {
  if (
    window.userInfo &&
    window.userInfo.SELF &&
    window.userInfo.SELF.enable_range
  ) {
    return true;
  } else {
    return false;
  }
};
const isHeadShowable = (item, props, head) => {
  //if(isEvGroup(item)) return false
  let username = (((props || {}).auth || {}).userinfo || {}).username;
  if (!username || !head) return true;
  let blacklist = null;
  let whitelist = null;
  let colName = head.key;
  for (let idx in filterHeading) {
    if (
      filterHeading[idx].users &&
      filterHeading[idx].users.indexOf(username) !== -1
    ) {
      whitelist = filterHeading[idx].whitelist || [];
      blacklist = filterHeading[idx].blacklist || [];
    }
  }

  if (whitelist !== null) return whitelist.indexOf(colName) !== -1;

  if (blacklist !== null) return whitelist.indexOf(colName) === -1;

  return true;
};

export const processData = (respObj, vehicleMap, callback) => {
  let historyData = [];
  let locationbodyfrom = [];
  let locationbodyto = [];

  for (let vehiclepath in respObj) {
    let vehicleno = vehicleMap[vehiclepath].vehicleno;
    let fueltype = _.get(vehicleMap, vehiclepath + ".vehiclemeta.fueltype");
    let model = vehicleMap[vehiclepath].vehicleModel
      ? vehicleMap[vehiclepath].vehicleModel.model
      : vehicleMap[vehiclepath].vehiclemeta
      ? vehicleMap[vehiclepath].vehiclemeta.model || "taby"
      : "taby2";
    // console.log("model",vehicleMap[vehiclepath].vehiclemeta,vehicleno)
    let odofrom = vehicleMap[vehiclepath].vehiclemeta
      ? vehicleMap[vehiclepath].vehiclemeta.odofrom
      : null;
    // console.log("odofrom",odofrom)

    for (let ridx in respObj[vehiclepath]) {
      let eachitem = respObj[vehiclepath][ridx];
      let starttime =
        eachitem.starttime != null ? new Date(eachitem.starttime) : null;
      let endtime =
        eachitem.endtime != null ? new Date(eachitem.endtime) : null;
      let duration =
        eachitem.tripduration != null
          ? parseFloat(eachitem.tripduration.toFixed(2))
          : null;
      let distance =
        eachitem.tripdistance != null
          ? parseFloat(eachitem.tripdistance.toFixed(2))
          : null;
      let fuelused =
        eachitem.fuelused != null && distance != null
          ? parseFloat(eachitem.fuelused.toFixed(2))
          : null;
      let mileage =
        fuelused != null && fuelused > 0 && distance != null
          ? parseFloat(distance / fuelused).toFixed(2)
          : null;
      let avgspeed = eachitem.avgspeed;
      let startodo =
        eachitem.startodo != null &&
        odofrom !== null &&
        odofrom === "can_odometer"
          ? parseFloat(eachitem.startodo.toFixed(0))
          : null;
      let endodo =
        eachitem.endodo != null &&
        odofrom !== null &&
        odofrom === "can_odometer"
          ? parseFloat(eachitem.endodo.toFixed(0))
          : null;
      let tripscore = eachitem.tripscore;
      let startloc =
        "(" + String(eachitem.lat) + "," + String(eachitem.lng) + ")";
      let endloc =
        "(" + String(eachitem.late) + "," + String(eachitem.lnge) + ")";
      let idlingtime =
        eachitem.idlingtime != null
          ? parseFloat(
              (eachitem.idlingtime > 0
                ? eachitem.idlingtime / 1000 / 60
                : 0
              ).toFixed(2)
            )
          : null;
      let acidlingtime =
        eachitem.acidlingtime != null
          ? parseFloat(
              (eachitem.acidlingtime > 0
                ? eachitem.acidlingtime / 1000 / 60
                : 0
              ).toFixed(2)
            )
          : null;
      let EndLatLng = [eachitem.late, eachitem.lnge];
      let StartLatLng = [eachitem.lat, eachitem.lng];
      let startfl = eachitem.startfl;
      let endfl = eachitem.endfl;
      let startdte = eachitem.startdte;
      let enddte = eachitem.enddte;
      let range =
        fuelused != null && fuelused != 0
          ? ((100 / fuelused) * distance).toFixed(2)
          : 0;
      locationbodyfrom.push([eachitem.lat, eachitem.lng]);
      locationbodyto.push([eachitem.late, eachitem.lnge]);
      if (window.userInfo.SELF.pbl_report === "SHOW") {
        let hrs = eachitem.tripduration;
        let ophours = changeToHours(hrs);
        let consumption = (fuelused / Math.max(1, hrs / 60)).toFixed(2);
        historyData.push({
          vehicleno,
          model,
          starttime,
          endtime,
          duration,
          distance,
          fuelused,
          mileage,
          avgspeed,
          idlingtime,
          acidlingtime,
          startodo,
          endodo,
          tripscore,
          fueltype,
          startfl,
          endfl,
          StartLatLng,
          EndLatLng,
          startloc,
          endloc,
          startdte,
          enddte,
          hrs,
          ophours,
          consumption,
        });
      } else {
        historyData.push({
          vehicleno,
          model,
          starttime,
          endtime,
          duration,
          distance,
          fuelused,
          mileage,
          avgspeed,
          idlingtime,
          acidlingtime,
          startodo,
          endodo,
          tripscore,
          fueltype,
          startfl,
          endfl,
          StartLatLng,
          EndLatLng,
          startloc,
          endloc,
          startdte,
          enddte,
          range,
        });
      }
    }
  }

  callback(historyData);
  // GeoCodeAPIs.getAddress(locationbodyfrom).then(
  //   (resp) => {
  //     for (let idx in historyData) {
  //       historyData[idx].startloc =
  //         (resp[idx] ? resp[idx][1] : "") +
  //         " (" +
  //         historyData[idx].startloc +
  //         ")";
  //     }
  //     callback(historyData);
  //     if (historyData.length) getFuelPrices(resp, historyData, callback);
  //   },
  //   (resp) => {
  //     console.log(resp);
  //   }
  // );
  // GeoCodeAPIs.getAddress(locationbodyto).then(
  //   (resp) => {
  //     for (let idx in historyData) {
  //       historyData[idx].endloc =
  //         (resp[idx] ? resp[idx][1] : "") +
  //         " (" +
  //         historyData[idx].endloc +
  //         ")";
  //     }
  //     callback(historyData);
  //   },
  //   (resp) => {
  //     console.log(resp);
  //   }
  // );
};

const getHistory = (schema, data, store) => {
  // mixpanel.track("User Looks For Daily Report", {
  //   Platform: "Web",
  //   Application: "Web",
  //   Screen: "Report",
  // });
  window.resetIndex();
  window.getButtonClicked = true;
  schema.showPage = true;
  schema.finalData = null;
  let saveState = null;
  let tableStateData = null;
  window.graphDataErr = "";
  let starttime = data.starttime.unix() * 1000;
  let endtime = data.endtime.unix() * 1000;
  let vehicleDataForReport = {};
  let fixedQueryLimit = 700;
  let splitedVehicles = [];
  data.vehicle =
    window.selectedItems && window.selectedItems.length
      ? window.selectedItems
      : window.itemClicked
      ? window.selectedVehicles
      : [];
  if (!data.vehicle.length) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "Please select a vehicle",
        content: "Please select a vehicle",
        createAt: Date.now(),
        autoClose: 8000,
        showError:true
      },
    });
    return;
  }
  if (endtime - starttime > 1000 * 60 * 60 * 24 * 35) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "You can't select a date range of more than 35 days",
        content: "You can't select date range of more than 35 days",
        createAt: Date.now(),
        autoClose: 8000,
        showError:true
      },
    });
    return;
  }
  if (starttime >= endtime) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "Start time should be less than the end time",
        content: "Start time should be less than the end time",
        createAt: Date.now(),
        autoClose: 8000,
        showError:true
      },
    });
    return;
  }
  // if(starttime === endtime){
  //   endtime = endtime + (1000 * 60 * 60 * 24 - 60000)
  // }
  // let tempEndtime = endtime
  // let value=moment(tempEndtime).startOf('day')
  // tempEndtime = (value).unix() * 1000;
  // let a = (1000 * 60 * 60 * 24) - 60000
  // let diff = endtime - tempEndtime
  // if(diff === a ){
  //   endtime = endtime + 60000
  // }
  let days = endtime - starttime;
  schema.count = 0;
  days = Math.ceil(days / 86400000); //total days
  let queryLimit = data.vehicle.length * days; // total query limit
  schema.count = Math.ceil(queryLimit / fixedQueryLimit); // page number
  schema.splitCount = parseInt(data.vehicle.length / schema.count); // total vehicle / total pages
  if (schema.splitCount > 50) schema.splitCount = 50;

  let startIndex = 0;
  let endIndex = schema.splitCount;
  for (let pages = 0; pages < schema.count; pages++) {
    let page = [];
    for (let idx in data.vehicle) {
      if (idx >= startIndex && idx <= data.vehicle.length) {
        if (idx <= endIndex - 1) page.push(data.vehicle[idx].id);
      }
    }
    splitedVehicles.push(page);
    startIndex = endIndex;
    endIndex = startIndex + schema.splitCount;
    if (pages === schema.count - 1 && startIndex <= data.vehicle.length) {
      if (data.vehicle.length - startIndex > 0) {
        schema.count++;
      }
    }
  }
  if (data.vehicle && data.vehicle.length) {
    if (window.setReportWindowTabBusy)
      window.setReportWindowTabBusy(schema, true);
    const handleSuccess = (resp) => {
      window.dataForAll = resp;
      if (window.setReportWindowTabBusy)
        window.setReportWindowTabBusy(schema, false);
      processData(resp, store.vehicleMap, (data) => {
        schema.finalData = data;
        vehicleDataForReport = {
          endtime: endtime,
          starttime: starttime,
          rangeVehicles: splitedVehicles,
          reportName: schema.key,
          rangeFirstData: data,
          selectedVehicles: data.vehicle,
          canDailyPageno: schema.count,
          showPage: schema.showPage,
          selectedDailyVehicles: data.vehicle,
        };
        store.dispatch({
          type: actions.SELECTED_VEHICLE_ID,
          data: vehicleDataForReport,
        });
        if (tableStateData && tableStateData[0]) {
          tableStateData[0].body = data;
          tableStateData[0].busy = false;
          saveState(tableStateData[0], tableStateData[1], tableStateData[2]);
        }
        if (schema.content[0].ref) {
          schema.content[0].ref.setData(data);
        }
      });
    };
    if (schema.content[0].ref) {
      schema.content[0].ref.setBusy(true);
      saveState = schema.content[0].ref.props.saveState;
      tableStateData = [
        schema.content[0].ref.state,
        schema.content[0].ref.props.schemaKey,
        schema.content[0].ref.props.data,
      ];
    }
    let body = {
      // vehicleid: data.vehicle.map((item) => {
      //   return item.data.vehicleid;
      // }),
      vehicleid: splitedVehicles[0],
      starttime: starttime,
      endtime: endtime,
      tzoffset: momentTZ().utcOffset() * 60,
    };
    if (window.showNoGpsFixData === true) {
      body.fixqfilter = false;
    }
    ReportAPIs.getPrecomputeDailytrips(body).then(handleSuccess, (r) => {
      handleSuccess({});
    });
  } else {
    window.dataForAll = null;
    window.graphDataErr = "Please Select Vehicle";

    if (window.InMapForceUpdate) {
      window.InMapForceUpdate();
    }
    if (window.InGraphControlForceUpdate) {
      window.InGraphControlForceUpdate();
    }
    // window.dispatchStoreEvent({
    //   type: actions.GRAPHSET_STATE_CHANGED,
    //   data: 0,
    // });
    if (window.setReportWindowTabBusy)
      window.setReportWindowTabBusy(schema, false);
    return;
  }
};

const flipRangeWrap = flipRange.call(this, (report) => {
  report.schema.toolbar[4].onClick = report.odometerRange
    ? onFetchOdo(getHistory)
    : getHistory;
});

const download = (schema, data, store) => {
  // mixpanel.track("User Downloads  Daily Report", {
  //   Platform: "Web",
  //   Application: "Web",
  //   Screen: "Report",
  // });
  // console.log("frm daily",window.selectedItems)

  let strictColumns =
    store.groupTree.children.filter((g) => (g.path || "").indexOf("1259") > -1)
      .length > 0; // kushalsslp
  let filterdData = schema.content[0].ref.state.body;
  if (!filterdData.length) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "No data Available",
        content: "No data Available",
        createAt: Date.now(),
        autoClose: 8000,
        showError:true
      },
    });
    return;
  }
  schema.finalData = filterdData;
  if (schema.finalData) {
    // console.log(this.finalData)
    let finalData = _.map(schema.finalData, (r) => {
      r = Object.assign({}, r);
      r.starttime = moment(r.starttime).format(dateFormat);
      r.endtime = moment(r.endtime).format(dateFormat);
      if (strictColumns) {
        r.startloc = stripLoc(r.startloc);
        r.endloc = stripLoc(r.endloc);
      }
      return r;
    });
    if (strictColumns) {
      finalData = _.map(finalData, (r) => {
        if (window.userInfo.SELF.pbl_report === "SHOW") {
          let head = schema.content[0].head;
          let newHead = [];
          for (let idx in head) {
            if (
              head[idx].key !== "cpk" &&
              head[idx].key !== "mileage" &&
              head[idx].key !== "idlingtime" &&
              head[idx].key !== "acidlingtime"
            ) {
              newHead.push(head[idx].key);
            }
          }
          return _.pick(r, newHead);
        }
        let headings = schema.content[0].head
          .filter((c) =>
            c.isShowable ? c.isShowable(data.vehicle, store, c) : true
          )
          .map((c) => c.key);
        return _.pick(r, headings);
      });
    }
    // let removeHead = ["mileage", "idlingtime", "acidlingtime", "tripscore", "startdte", "enddte","cpk", "fuelprice", "uid", "starttime__processed__", "endtime__processed__" ]
    // finalData.map((item) => {
    //   for(let idx in removeHead){
    //     for(let ldx in item){
    //       if(ldx === removeHead[idx]) delete item[ldx]
    //     }
    //   }
    // })
    let heads = schema.content[0].head;
    let removeHeads = [
      "mileage",
      "acidlingtime",
      "tripscore",
      "startdte",
      "enddte",
      "cpk",
      "fuelprice",
      "uid",
      "starttime__processed__",
      "endtime__processed__",
      // "fuelused",
      "ophours",
      "consumption",
      "cph",
    ];
    if (isEvGroup(data.vehicle)) {
      removeHeads.push("idlingtime");
    }
    heads = heads.filter((head) => {
      if (!removeHeads.includes(head.key)) {
        return head;
      }
    });
    let newData = [];
    for (let idx in finalData) {
      let tempdata = {};
      for (let rdx in heads) {
        if (heads[rdx].key in finalData[idx]) {
          let key = heads[rdx].key;
          let name = heads[rdx].name;
          tempdata[name] = finalData[idx][key];
        }
      }
      newData.push(tempdata);
    }
    setTimeout(() => { 
      JSONToCSVConvertor(newData, "rangeReport", false);
    }, 500);
  }
};

const schema = {
  key: "range_report",
  name: "Range Report",
  showPage: false,
  count: null,
  splitCount:null,
  finalData:null,
  toolbar: [
    {
      key: "vehicle",
      type: schemaTypes.MULTI_SELECT,
      storeData: (state) => {
        return {
          data: (() => {
            let newMap = {};
            for (let idx in state.vehicleMap) {
              if (idx.indexOf("user") === -1) {
                newMap[idx] = state.vehicleMap[idx];
              }
            }
            return newMap;
          })(),
          name: "vehicleno",
          id: "vehicleid",
        };
      },
      maxCount: 6000,
      onItemChange: changeVehicle.bind(this),
      defaultValue: () => {
        return {
          data: window.selectedVehicles.map((i) => {
            return i.id;
          }),
          updatedAt: window.selectedVehiclesUpdatedAt,
        };
      },
    },
    {
      key: "switch",
      type: schemaTypes.BUTTON,
      iconType: "class",
      icon: "fa fa-exchange",
      onClick: flipRangeWrap,
      tooltip: "Switch between date range and odometer",
      isShowable: canShowRangeSwitch,
    },
    {
      key: "starttime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "Start Date",
      model: Date.now() - 1000 * 60 * 60 * 24,
      hideTime: true,
      schemaKey: "range_report",
    },
    {
      key: "endtime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "End Date",
      model: Date.now() - 1000 * 60,
      hideTime: true,
      schemaKey: "range_report",
    },
    {
      key: "get_history",
      type: schemaTypes.BUTTON,
      name: "Get Range Report",
      onClick: getHistory,
    },
    {
      key: "download",
      type: schemaTypes.BUTTON,
      iconType: "class",
      icon: "fa fa-download",
      onClick: download,
      tooltip: "Download Page",
    },
  ],
  content: [
    {
      key: "dataTable",
      type: schemaTypes.IN_TABLE,
      position: {
        width: 12,
        height: 12,
        left: 0,
        top: 0,
      },
      head: [
        {
          key: "vehicleno",
          name: "",
          name: "Vehicle No",
          isShowable: isHeadShowable,
        },
        { key: "model", name: "Model", isShowable: isHeadShowable },
        {
          key: "starttime",
          name: "Start Time",
          type: "DATE",
          format: dateFormat,
          width: 1.5,
          isShowable: isHeadShowable,
        },
        {
          key: "endtime",
          name: "End Time",
          type: "DATE",
          format: dateFormat,
          width: 1.5,
          isShowable: isHeadShowable,
        },
        // {key:'duration', name:'Duration (min)'},
        { key: "distance", name: "Distance (km)", isShowable: isHeadShowable },
        {
          key: "startfl",
          name: "Start SOC",
          isShowable: (item) => isEvGroup(item),
        },
        {
          key: "endfl",
          name: "End SOC",
          isShowable: (item) => isEvGroup(item),
        },
        { key: "startdte", name: "Start DTE" },
        { key: "enddte", name: "End DTE" },
        //   { key: "fuelused", name: "Fuelused (ltr)", isShowable: (item, props, head) => !isEvGroup(item) && isHeadShowable(item, props, head) },
        {
          key: "fuelused",
          name: " SOC Consumed % ",
          isShowable: (item) => isEvGroup(item),
        },
        { key: "range", name: "Range" },

        // { key: "mileage", name: "Mileage (kmpl)", isShowable: isHeadShowable },
        // { key: "cpk", name: "CPK (₹)", isShowable: isHeadShowable },
        // {
        //   key: "fuelprice",
        //   name: "Fuel Price (₹)",
        //   isShowable: isHeadShowable,
        // },
        //   {
        //     key: "avgspeed",
        //     name: "Avg Speed (kmph)",
        //     isShowable: isHeadShowable,
        //   },
        //   {
        //     key: "idlingtime",
        //     name: "Idling Time (min)",
        //     isShowable: (item, props, head) =>
        //      !isEvGroup(item) && isIdlingShowable(item, props) && isHeadShowable(item, props, head),
        //   },
        // {key:'acidlingtime', name:'AC Idling (min)', isShowable: (item, props, head)=> isIdlingShowable(item, props) && isHeadShowable(item, props, head)},
        //   { key: "startodo", name: "Start Odo (km)", isShowable: isHeadShowable },
        //   { key: "endodo", name: "End Odo (km)", isShowable: isHeadShowable },
        // {key:'tripscore', name:'Trip Score'},
        //   { key: "ophours", name: "Time of operation in hours" },
        //   { key: "consumption", name: "Avg consumption (ltrs/hour)" },
        //   { key: "cph", name: "CPH" },
        {
          key: "startloc",
          name: "Start Location",
          width: 2,
          isShowable: isHeadShowable,
          onClick: (d, item) => {
            window.showInGoogleMaps(item.StartLatLng[0], item.StartLatLng[1]);
          },
        },
        {
          key: "endloc",
          name: "End Location",
          width: 2,
          isShowable: isHeadShowable,
          onClick: (d, item) => {
            window.showInGoogleMaps(item.EndLatLng[0], item.EndLatLng[1]);
          },
        },
      ],
    },
  ],
};
export default schema;
